module.exports = __webpack_public_path__ + "img/FR28533.acd71a5c.png";